export { PaymentCard } from "./PaymentCard";
export { DesktopVacationRentalsBookWorkflow } from "./DesktopVacationRentalsBookWorkflow";
export { MobileVacationRentalsBookWorkflow } from "./MobileVacationRentalsBookWorkflow";
export { VacationRentalsPriceBreakdownDropdown } from "./VacationRentalsPriceBreakdownDropdown";

export const AGENT_FEE = 10;
